import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import TranslatedDocFileViewer from "../../viewers/docs-viewer";


const FilePreviewModal = ({
    show,
    onHide,
    signedUrl,
    isPdfOrHtml,
    title = "File Preview",
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ height: "70vh", padding: 0, overflow: "auto" }}>
                {signedUrl ? (
                    isPdfOrHtml ?
                        <iframe
                            src={signedUrl}
                            title="File Preview"
                            width="100%"
                            height="100%"
                            style={{
                                border: "none",
                            }}
                        /> :
                        <TranslatedDocFileViewer fileUrl={signedUrl} />
                ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center h-100">
                        <Spinner animation="border" />
                        <p className="mt-3 mb-0">No file available for preview.</p>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>

                {signedUrl && (
                    <Button
                        variant="primary"
                        onClick={() => window.open(signedUrl, "_blank")}
                    >
                        Open in New Tab
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default FilePreviewModal;